export enum MetadataMaskyooStatus {
  NotAnswer = 0,
  Answer = 1,
  Callback = 2,
  CallMeBackFinished = 3,
  CallRouter = 4,
  
  All = -1
}
